import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';
import styles from "./ricercaFocolaio.module.css";
import Table from "../../../components/table/Table";
import Button from "../../../components/button/Button";
import Spinner from "../../../components/spinner/Spinner";
import Utils from "../../../utils/Utils";
import moment from "moment";
import OggettiUtili from "../../../utils/OggettiUtili"
import Input from "../../../components/textbox/Input";
import Calendar from "../../../components/calendar/Calendar";
import $ from 'jquery'
import history from "../../../utils/History";
import Modale from "../../../components/modale/Modale"
import FocolaiServices from "../../../services/FocolaiServices";
import toasterConfig from "../../../config/toasterConfig";
import ToasterSingleton from "../../../singleton/ToasterSingleton";
import SelectAutocomplete from "../../../components/selectAutocomplete/SelectAutocomplete";


class RicercaFocolaio extends Component {

    state = {
        tableLenght: 10,
        rows: [],
        initialRows: [],
        noSectionActive: true,
        loading: false,
        malattie: JSON.parse(sessionStorage.getItem("malattieFocolaiPerDescrizione")),
        malattiePerTabella: JSON.parse(sessionStorage.getItem("malattieFocolaiPerCodice")),
        sections: [
            {
                malattia: ""
            },
            {
                etichetta: ""
            },
            {
                dataCompilazioneDa: "",
                dataCompilazioneA: ""
            },
        ],
        disabledButtons: true,
        sezioneInErrore: [3],
        suggestions: [],
        totalElements: 0,
        showTable: false,
        disabledTableButtons: true,
        page: 0,
        totalPages: 0,
        size: 10,
        rigaSelezionata: null
    };


    cols = [
        {key: "checked", name: "", tipo: "checkbox", isRadio: true},
        {
            key: "malattia",
            name: "Tables.RicercaFocolai.malattia",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: this.state.malattiePerTabella,
            campo: "descrizione"
        },
        {key: "etichetta", name: "Tables.RicercaFocolai.etichetta", sortDirection: "none"},
        {
            key: "ulss",
            name: "Tables.RicercaFocolai.ulss",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Ulss
        },
        {key: "dataCompilazione", name: "Tables.RicercaFocolai.dataCompilazione", sortDirection: "none", tipo: "data"},
        {key: "numeroCasi", name: "Tables.RicercaFocolai.casi", sortDirection: "none"},
        {
            key: "comunita",
            name: "Tables.RicercaFocolai.comunita",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.Collettivita,
            campo: "descrizione"
        },
        {
            key: "stato",
            name: "Tables.RicercaFocolai.stato",
            sortDirection: "none",
            tipo: "dizionario",
            oggetto: OggettiUtili.statoFocolaio,
            campo: "descrizione"
        },
    ]


    segnalazioni = [];

    constructor(props) {
        super(props);
        this.riceviValore = this.riceviValore.bind(this);
        this.pulisciTutto = this.pulisciTutto.bind(this);
        this.selezionaFocolaio = this.selezionaFocolaio.bind(this);
        this.executeSearch = this.executeSearch.bind(this);
        this.goToInserisciNuovo = this.goToInserisciNuovo.bind(this);
        this.modificaFocolaio = this.modificaFocolaio.bind(this);
        this.archiviaFocolaio = this.archiviaFocolaio.bind(this);
        this.changePageTable = this.changePageTable.bind(this)
        this.changePaginationTable = this.changePaginationTable.bind(this)
        this.aggiungiToaster = this.aggiungiToaster.bind(this)
    }

    goToInserisciNuovo() {
        let path = "\InformazioniFocolaio";
        history.push({
            pathname: path,
            malattia: this.state.sections[0].malattia ? this.state.sections[0].malattia : null,
            etichetta: this.state.sections[1].etichetta ? this.state.sections[1].etichetta : null
        });
        sessionStorage.removeItem("parametriRicercaFocolai")
    }

    selezionaFocolaio(row, isChecked) {
       this.setState({disabledTableButtons: !isChecked, rigaSelezionata: row})
    }

    modificaFocolaio() {

        this.props.history.push(
            {
                pathname: '/InformazioniFocolaio',
                idFocolaio: this.state.rigaSelezionata.idFocolaio
            });

    }

    archiviaFocolaio() {
        let idFocolaio = this.state.rigaSelezionata.idFocolaio;

        this.setState({loading: true});

        FocolaiServices.postArchiviaFocolaio(idFocolaio).then((response) => {
            let rows = this.state.rows;
            let i = Utils.checkObjectInArrayByObjectId(rows, "idFocolaio", idFocolaio);
            let focolaioAggiornato = this.state.rows[i];
            focolaioAggiornato.statoSegnalazione = OggettiUtili.statoFocolaioByLabel.Archiviato.codice;
            focolaioAggiornato.checked = false;

            this.setState({loading: false, rows: rows});
            this.executeSearch();

        }).catch((reason) => {
            console.log("[Error] GetFocolai in errore ");
            this.setState({loading: false});
        });

    }


    componentDidMount() {
        ToasterSingleton.instance().pulisci()
        ToasterSingleton.instance().sottoscrizione(this)
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
        let that = this;
        let paramsRicerca = sessionStorage.getItem("parametriRicercaFocolai")?JSON.parse(sessionStorage.getItem("parametriRicercaFocolai")):null
        if(paramsRicerca){
            let newSections = [
                {
                    malattia: paramsRicerca.malattia?paramsRicerca.malattia:""
                },
                {
                    etichetta: paramsRicerca.etichetta?paramsRicerca.etichetta:""
                },
                {
                    dataCompilazioneDa: paramsRicerca.dataCompilazioneDa?paramsRicerca.dataCompilazioneDa:"",
                    dataCompilazioneA: paramsRicerca.dataCompilazioneA?paramsRicerca.dataCompilazioneA:""
                }
            ]
            this.setState({sections:newSections,disabledButtons:false,page:paramsRicerca.page?paramsRicerca.page:0,size:paramsRicerca.size?paramsRicerca.size:10})
            this.sendRequest(paramsRicerca);
        }
        $(document).ready(() => {
            this.setCalendarIconToActiveSection();
            $(document).on("click", function (e) {

                switch (e.target.id) {
                    case "idMalattia":
                    case "idEtichetta":
                    case "dataCompilazioneDa":
                    case "dataCompilazioneA":
                    case "idButtonSearch":
                        break;
                    default: {
                        if (e.target.id.indexOf("suggestion") == 0) {
                            break;
                        }
                        that.setState({noSectionActive: true});
                    }
                }
            });
        });
    }

    componentWillUnmount() {
        ToasterSingleton.instance().cancellazioneSottoscrizione()
    }

    componentDidUpdate() {
        sessionStorage.setItem("pathProvenienza", this.props.pathProvenienza)
    }

    riceviValore(field, event) {
        let newSections = this.state.sections
        let disabled ;

        if (field == "malattia") {
            newSections[0].malattia = event.target.value;
        } else if (field == "etichetta") {
            newSections[1].etichetta = event.target.value;
        } else if (field.currentTarget.id == "dataCompilazioneDa") {
            newSections[2].dataCompilazioneDa = field.target.value;
        } else if (field.currentTarget.id == "dataCompilazioneA") {
            newSections[2].dataCompilazioneA = field.target.value;
        }


        if ((this.state.sections[0].malattia && this.state.sections[0].malattia.codice !== "" &&
            document.getElementById("idMalattia").value !== "") ||
            (this.state.sections[1].etichetta != "" && !this.state.sections[1].etichetta.startsWith(" ")) ||
            (this.state.sections[2].dataCompilazioneA != "" && this.state.sections[2].dataCompilazioneDa != ""
                && !Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneDa), "-")
                && !Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneA), "-")
                && !Utils.checkDateInterval(this.state.sections[2].dataCompilazioneA, this.state.sections[2].dataCompilazioneDa))) {
            disabled = false;
        } else {
            disabled = true;
        }

        this.setState({sections: newSections, disabledButtons: disabled});
        console.log("ricevi:  " + this.state.disabledButtons)
    }

    setCalendarIconToActiveSection() {
        $("#da .input-group-addon").css("margin-right", 0);
        $("#da .input-group").css("padding-right", "15px");

        $("#a .input-group-addon").css("margin-right", 0);
        $("#a .input-group").css("padding-right", "15px");
    }

    pulisciTutto() {

        let cleaned = [
            {
                malattia: ""
            },
            {
                etichetta: ""
            },
            {
                dataCompilazioneDa: "",
                dataCompilazioneA: ""
            }
        ];

        this.setState({
            sections: cleaned,
            sezioneInErrore: {},
            noSectionActive: true,
            disabledButtons: true,
            showTable: false,
            page: 0
        });
        document.getElementById("idMalattia").value = "";
        $(document).ready(function () {
            $('.selectpicker').selectpicker('refresh')
        });
        sessionStorage.removeItem("parametriRicercaFocolai")
    }

    checkBlockError() {

        let err = [];
        let that = this;
        if (this.state.sections[0].malattia.length === 0) {
            err[1] = true;
            that.setState({sezioneInErrore: err});
        } else that.setState({sezioneInErrore: err});

        if (this.state.sections[1].etichetta.length === 0) {
            err[2] = true;
            that.setState({sezioneInErrore: err});
        } else that.setState({sezioneInErrore: err});

        if (
            !moment(
                this.state.sections[2].dataCompilazioneDa,
                "DD/MM/YYYY",
                true
            ).isValid() || !moment(
            this.state.sections[2].dataCompilazioneA,
            "DD/MM/YYYY",
            true
            ).isValid()
        ) {
            err[3] = true;
            that.setState({sezioneInErrore: err});
        } else that.setState({sezioneInErrore: err});

    }

    isValidForm() {
        if (
            !(
                (this.state.sezioneInErrore[1]) ||
                (this.state.sezioneInErrore[2]) ||
                (this.state.sezioneInErrore[3])
            )
        )
            return true
        else
            return false
    }

    executeSearch() {
        let that = this;
        setTimeout(function () {
            if (that.isValidForm()) {
                that.setState({loading: true});
                that.sendRequest(null,true);
                let params = that.buildParams()
                sessionStorage.setItem("parametriRicercaFocolai",JSON.stringify(params))
            } else {
                console.log("[ERRORE]");
            }

        }, 50);
    }

    sendRequest(paramsInput,executeSearch) {

        this.setState({loading: true});
        let params = paramsInput?paramsInput:{}

        if (this.state.sections[0].malattia) {
            params["malattia"] = this.state.sections[0].malattia;
        }
        if (this.state.sections[1].etichetta) {
            params["etichetta"] = this.state.sections[1].etichetta;
        }
        if (this.state.sections[2].dataCompilazioneDa && this.state.sections[2].dataCompilazioneA) {
            params["dataCompilazioneDa"] = Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneDa.toUpperCase());
            params["dataCompilazioneA"] = Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneA.toUpperCase());
        }
        if(executeSearch){
            params.page = 0
        }


        FocolaiServices.getFocolai(params)
            .then((data) => {
                if (!data.data.content || data.data.content.length == 0) {
                    this.aggiungiToaster();
                }

                let res = data.data.content;
                let newPage = 0
                this.setState({
                    rows: res,
                    totalElements: data.data.totalElements,
                    showTable: true,
                    loading: false,
                    page:params.page,
                    totalPages: data.data.totalPages
                });
            })
            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({rows: [], totalElements: 0, showTable: true, loading: false});
            });
    }

    aggiungiToaster() {

        ToasterSingleton.instance().aggiuntaToaster({
            type: toasterConfig.types.informational,
            text: ["Toasters.Messages.no_result"],
            timestamp: Date.now()

        })

    }

    buildParams(sort, direction, page, size) {

        let params = {};

        if (this.state.sections[0].malattia) {
            params["malattia"] = this.state.sections[0].malattia;
        }
        if (this.state.sections[1].etichetta) {
            params["etichetta"] = this.state.sections[1].etichetta;
        }
        if (this.state.sections[2].dataCompilazioneDa && this.state.sections[2].dataCompilazioneA) {
            params["dataCompilazioneDa"] = Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneDa.toUpperCase());
            params["dataCompilazioneA"] = Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneA.toUpperCase());
        }

        if (page != null) {
            params.page = page
        }

        if (sort != null) {
            params.sort = sort
        }

        if (direction != null) {
            params.order = direction
        }

        return params;
    }


    changePageTable(sort, direction, page, size) {

        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            if (size !== this.state.size) {
                params.size = this.state.size
            } else {
                params.size = size
            }
        }
        sessionStorage.setItem("parametriRicercaFocolai",JSON.stringify(params))
        FocolaiServices.getFocolai(params)
            .then((data) => {
                let res = data.data.content;
                this.setState({
                    rows: res,
                    totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages,
                    page: page
                });
            })

            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({rows: [], totalElements: 0});
            });
    }

    changePaginationTable(sort, direction, page, size) {

        let params = this.buildParams(sort, direction, page, size);

        if (size != null) {
            params.size = size
        }
        sessionStorage.setItem("parametriRicercaFocolai",JSON.stringify(params))
        FocolaiServices.getFocolai(params)
            .then((data) => {
                let res = data.data.content;
                this.setState({
                    rows: res,
                    totalElements: data.data.totalElements,
                    totalPages: data.data.totalPages,
                    page: page,
                    size: size
                });
            })
            .catch(() => {
                console.log("[Error] GetFocolai in errore ");
                this.setState({rows: [], totalElements: 0, size: size});
            });
    }

    render() {
        const {t} = this.props;
        const bluButton = "btnBlu";
        const whiteButton = "btnWhite";

        const firstSection = (

            <div className={styles.fieldContainer}>
                <p className={styles.labelHeader}>{t("GestioneSegnalazioni.ricerca.malattia")} <span
                    className={styles.mandatoryColor}>*</span></p>
                <SelectAutocomplete
                    id={"idMalattia"}
                    field={"malattia"}
                    newSelect={true}
                    onChange={this.riceviValore}
                    value={this.state.sections[0].malattia}
                    functionMap={Utils.mapToArray(this.state.malattie).map((oggetto) => {
                        return (<option value={oggetto.codice}>{oggetto.codDesc}</option>)
                    })}>
                </SelectAutocomplete>
            </div>

        );

        const secondSection = (
            <div className={styles.fieldContainer}>
                <p className={styles.labelHeader}>{t("GestioneFocolai.ricerca.etichetta")} <span
                    className={styles.mandatoryColor}>*</span></p>
                <Input id={"idEtichetta"} onChange={this.riceviValore} field={"etichetta"}

                       value={this.state.sections[1].etichetta} placeholder={t("GestioneFocolai.ricerca.etichetta")}
                       onValidate={(!Utils.isObjectEmpty(this.state.sections[1].etichetta)) ? (this.state.sections[1].etichetta.replace(/ +/g, "").length === 0 || this.state.sections[1].etichetta.startsWith(" ") ? 1 : 2) : 0}
                       errorMessage={"Etichetta non valida"}
                ></Input>
            </div>

        );

        const dataSegnalazioneSection = (
            <div>
                <p className={styles.labelHeader}>{t("GestioneFocolai.ricerca.data_compilazione")} <span
                    className={styles.mandatoryColor}>*</span></p>

                <div>
                    <div className={styles.dataSegnalazioneGroup} style={{marginBottom: "0.5rem"}}>
                        <label className={styles.labelStyle} htmlFor="da">{t("Utils.da")}</label>
                        <div id="da">
                            <Calendar id={"dataCompilazioneDa"} value={this.state.sections[2].dataCompilazioneDa}
                                      onChange={this.riceviValore} field={"dataCompilazioneDa"}

                                      errorMessage={Utils.isDateInValid(this.state.sections[2].dataCompilazioneDa) ? t(Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("GestioneFocolai.ricerca.dataDa_non_valida"))) : ""}
                                      error={Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneDa), "-") &&
                                      this.state.sections[2].dataCompilazioneDa !== ""}>
                            </Calendar>
                        </div>
                    </div>

                    <div className={styles.dataSegnalazioneGroup}>
                        <label className={styles.labelStyle} htmlFor="a">{t("Utils.a")}</label>
                        <div id="a">
                            <Calendar id={"dataCompilazioneA"} value={this.state.sections[2].dataCompilazioneA}
                                      field={"dataCompilazioneA"} onChange={this.riceviValore}
                                      errorMessage={
                                          Utils.isDateInValid(this.state.sections[2].dataCompilazioneA) ||
                                          Utils.checkDateInterval(this.state.sections[2].dataCompilazioneA, this.state.sections[2].dataCompilazioneDa) ?
                                              t("GestioneFocolai.ricerca.intervallo_date_non_valido") :
                                              ""
                                      }
                                      error={(Utils.isDateInValid(Utils.transformDateForBackend(this.state.sections[2].dataCompilazioneA), "-") &&
                                          this.state.sections[2].dataCompilazioneA !== "") ||
                                      Utils.checkDateInterval(this.state.sections[2].dataCompilazioneA, this.state.sections[2].dataCompilazioneDa)}>
                            </Calendar>
                        </div>
                    </div>
                </div>
            </div>
        );


        const form = (
            <div className={styles.contenitoreRicerca}>
                <div className={styles.responsiveGrid}>
                    {firstSection}
                    {secondSection}
                </div>

                <div className={styles.responsiveGrid}>
                    {dataSegnalazioneSection}
                </div>

            </div>
        );

        const tableDiv = (
            <div className={styles.contenitoreTabella}>
                <Table cols={this.cols} rows={this.state.rows} title={t("GestioneFocolai.ricerca.titolo_tabella")}
                       empty={this.state.rows && this.state.rows.length == 0}
                       emptyMsg={t("Tables.RicercaFocolai.message")}
                       lengthEditable={true}
                       bigTable={true}
                       totalPages={this.state.totalPages}
                       page={this.state.page}
                       changePage={this.changePageTable}
                       changePagination={this.changePaginationTable}
                       onSelectCheckbox={this.selezionaFocolaio}
                       totalElements={this.state.totalElements}
                       tableLenght={this.state.size}
                />
            </div>
        );

        const spinnerDiv = (
            <div>
                <Spinner/>
            </div>
        );

        const tableButtonsDiv = (
            <div className={"row"} style={{marginTop: "5rem"}}>
                <div className={"col-sm-12 col-lg-3 mx-lg-auto"}>
                    <Button text={t("Buttons.modify")} disabled={this.state.disabledTableButtons}
                            onClick={this.modificaFocolaio}
                            className={"btnWhite"}
                            style={{height: "3rem", marginTop: "1rem", width: "100%"}}></Button>
                </div>
                <Modale
                    containerClass={"col-sm-12 col-lg-3 mx-lg-auto"}
                    classes="btnWhite" id={"annulla"} typeModal="modalOscura"
                    disabled={this.state.disabledTableButtons || (this.state.rigaSelezionata && this.state.rigaSelezionata.stato === OggettiUtili.statoFocolaioByLabel.Archiviato.codice)}
                    modalText={t("Messages.ERR_01_01_0A_0B")}
                    text={t("Buttons.store")}
                    title={t("GestioneFocolai.ricerca.archivia")}
                    style={{height: "3rem", marginTop: "1rem", width: "100%"}}
                    confirmFun={this.archiviaFocolaio}
                />
            </div>

        );

        const buttonDiv = (
            <div className={"row"}>
                <Button id={"idButtonClean"} text={t("Buttons.clean")} disabled={this.state.disabledButtons}
                        onClick={this.pulisciTutto} className={[whiteButton, "col-sm-12 col-lg-3 mx-lg-auto"].join(" ")}
                        style={{height: "3rem", marginTop: "1rem"}}></Button>
                <Button id={"idButtonSearch"} text={t("Buttons.search")} disabled={this.state.disabledButtons}
                        onClick={this.executeSearch} className={[bluButton, "col-sm-12 col-lg-3 mx-lg-auto"].join(" ")}
                        style={{height: "3rem", marginTop: "1rem"}}></Button>
                <Button id={"idButtonInsertNew"} text={t("Buttons.insert_new_focolaio")}
                        disabled={!this.state.disabledTableButtons} onClick={this.goToInserisciNuovo}
                        className={[whiteButton, "col-sm-12 col-lg-3 mx-lg-auto"].join(" ")}
                        style={{height: "3rem", marginTop: "1rem"}}></Button>
            </div>
        );

        return (

            <div className={styles.contenitore}>

                {ToasterSingleton.instance().renderToaster()}
                {form}

                <div className={styles.mandatoryColor}>{t("GestioneSegnalazioni.ricerca.legenda_obbligatorio")}</div>

                {this.state.loading ?
                    (<div>{spinnerDiv}</div>) : (<div/>)}

                {buttonDiv}

                {this.state.showTable ?
                    (<div> {tableDiv} {tableButtonsDiv}</div>) : (<div/>)}

            </div>
        )
    }

}

export default withTranslation('common')(RicercaFocolaio);
